import React, { useCallback, useState } from "react";
import LoginModal from "app/container/Checkout/LoginModal";

import styles from "./SignInBlock.module.scss";

const SignInBlock = () => {
  const [modalVisible, setModalVisible] = useState(false);

  const onClick = useCallback(() => {
    setModalVisible(true);
  }, []);

  return (
    <>
      <button className={styles.trigger} onClick={onClick} type="button">
        <span className="gkit-p-15 gkit-light">Returning customer? </span>
        <span className="gkit-p-15 gkit-bold gkit-charcoal">Sign in</span>
      </button>
      <LoginModal isVisible={modalVisible} handleModal={setModalVisible} />
    </>
  );
};

export default SignInBlock;
